import React, { useEffect, useMemo, useReducer, useState } from 'react';
import { useIntl , useLocation } from 'umi';
import classNames from 'classnames';
import { Icon } from 'tea-component';
import thumbsUpIcon from '@/pages/aigc/assets/svg/thumbs-up.svg';
import thumbsUpActiveIcon from '@/pages/aigc/assets/svg/thumbs-up-active.svg';
import thumbsDownIcon from '@/pages/aigc/assets/svg/thumbs-down.svg';
import thumbsDownActiveIcon from '@/pages/aigc/assets/svg/thumbs-down-active.svg';
import copyIcon from '@/pages/aigc/assets/svg/copy.svg';
import copyActiveIcon from '@/pages/aigc/assets/svg/copy-active.svg';
import shareActiveIcon from '@/pages/aigc/assets/svg/share-active.svg';
import shareIcon from '@/pages/aigc/assets/svg/share-default.svg';
import refreshIcon from '@/pages/aigc/assets/svg/refresh.svg';
import refreshActiveIcon from '@/pages/aigc/assets/svg/refresh-active.svg';
import ArchiveIcon from '@/pages/aigc/assets/svg/star.svg';
import ArchiveHighlightIcon from '@/pages/aigc/assets/svg/star-highlight.svg';
import copySuccessIcon from '@/pages/aigc/assets/svg/agent-copy-success.svg';
import kbAddUploadIcon from '@/pages/aigc/assets/svg/agent_add_file-active.svg';
import Operation from '@/pages/aigc/components/Operation';
import { updateChat, updateHistory } from '@/pages/aigc/pages/Agent/service/service';
import { copyToClipboard } from '@/pages/aigc/utils/utils';
import { v4 as uuidv4 } from 'uuid';
import './index.scss';
import useRefreshHooks from './useRefreshHooks';
import { useErrorTips } from '@/pages/aigc/hooks/useErrorTips';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import useChatShareHooks from '@/pages/aigc/pages/Agent/ChatShare/useChatShareHooks';
import { useBoolean, useDebounceEffect, useMemoizedFn, useSetState, useUpdateEffect } from 'ahooks';
import { FeedbackPopConfirm } from './components';
import { FEED_BACK_MESSAGES_LIST } from '../../../config/constant';
import { isEmpty, isFunction, concat } from 'lodash-es';
import { useChatList } from '@/pages/aigc/layouts/agentLayout/hooks';
import { useSessionId } from '../../hooks/useAgentModalSata';
import { hasReportDocument } from '../../utils';
import { useLocalState } from '../../hooks/useLocalState';
import KnowledgeBaseAddModal from '../KnowledgeBaseAddModal';
import { stripAnswerProtocolTags } from '../KnowledgeBaseAddModal/utils';


/** 反馈操作栏 hover 状态枚举 */
enum HoveringState {
  hoverUp = 'hoverUp',
  hoverDown = 'hoverDown',
  hoverCopy = 'hoverCopy',
  hoverRefresh = 'hoverRefresh',
  hoverShare = 'hoverShare',
  hoverArchive = 'hoverArchive',
}

/** 收藏状态 */
interface ArchiveState {
  archived: boolean;
  clicked: boolean;
}

type ArchiveAction =
  | { type: "TOGGLE_BOOKMARK"; }
  | { type: "RESET_CLICK"; };

/**
 * 回答反馈操作组件
 * 支持：点赞/点踩、复制、刷新、分享、收藏、加入知识库
 */
const FeedbackOperation = (props: any) => {
  const {
    className,
    like,
    messageId,
    userInfo,
    question,
    handleSubmit,
    answer,
    fileList,
    setShowShareChatDialog,
    handleLikeOrDislike,
    isLastQA,
    conversations,
    from,
    frontend_metadata,
  } = props;
  const { formatMessage } = useIntl();
  const { sessionId: routeSessionId } = useSessionId();
  const location = useLocation();
  const { query: { template } = {} as any } = location || ({} as any);
  const [isDSReportSession] = useLocalState('__dba_is_ds_report_session__', false);
  const isDsMode = template === 'dsReport' || isDSReportSession;
  const [likeState, setLikeState] = useState(like || 0); // 0: 未点赞 1: 点赞 -1: 点踩
  const [copyState, setCopyState] = useState(''); // success: 复制成功 error: 复制失败 ""：无状态
  const [feedBackVisibleStat, setFeedBackVisibleStat] = useSetState<{
    [key in 'copyVisible' | 'downVisible' | 'downTips']: boolean;
  }>({
    copyVisible: false,
    downVisible: false,
    downTips: false,
  });
  // 反馈弹窗
  const [feedbackPopState, { setTrue: setFeedbackPopOpen, setFalse: setFeedbackPopClose }] = useBoolean(false);
  // 加入知识库弹窗
  const [kbAddModalVisible, { setTrue: setKbAddModalOpen, setFalse: setKbAddModalClose }] = useBoolean(false);
  // hover时显示渐变色图标
  const [feedBackHoverStat, setFeedBackHoverStat] = useSetState<Record<HoveringState, boolean>>({
    hoverUp: false,
    hoverDown: false,
    hoverCopy: false,
    hoverRefresh: false,
    hoverShare: false,
    hoverArchive: false,
  });
  const showErrorTips = useErrorTips();
  const deleteMessageIds = conversations
    ?.slice(conversations.findIndex(item => item?.messageId === messageId))
    ?.map(conv => conv.messageId);
  const { handleRefreshConfirm } = useRefreshHooks({
    userInfo,
    question,
    deleteMessageIds,
    handleSubmit,
    fileList: fileList?.[messageId] || [],
    conversations,
    messageId,
    frontend_metadata,
  });
  // const { chatList } = useContext(ChatContext);
  const { chatList, fetchChatList, bookMarkedChats } = useChatList({ manual: true });
  const  {
    hoverUp,
    hoverDown,
    hoverCopy,
    hoverRefresh,
    hoverShare,
    hoverArchive,
  } = feedBackHoverStat;
  const { copyVisible, downVisible, downTips } = feedBackVisibleStat;
  // const from = voiceActiveBar ? 'copilot': 'agent';
  const sensitiveDataInfo = useMemo(() => {
    const chat = concat(chatList, bookMarkedChats).find((chat) => chat.session_id === routeSessionId);
    if (!chat) return { isSensitive: false, type: '' };
    const { sensitive_data_types, has_sensitive_data } = chat;
    const { dashboard, mgmt } = sensitive_data_types || {};
    const finalHasDashboard = dashboard || has_sensitive_data;
    if (finalHasDashboard && mgmt) {
      return { isSensitive: true, type: 'dba_menu_sensitive_content_both' };
    }
    if (finalHasDashboard) {
      return { isSensitive: true, type: 'dba_menu_sensitive_content' };
    }
    if (mgmt) {
      return { isSensitive: true, type: 'dba_menu_sensitive_content_mgmt' };
    }
    
    return { isSensitive: false, type: '' };
  }, [chatList, bookMarkedChats, routeSessionId]);

  const sensitiveConversation = sensitiveDataInfo.isSensitive;
  const { shareOnClickHandler } = useChatShareHooks();

  function archiveReducer(
    archiveState: ArchiveState,
    action: ArchiveAction
  ): ArchiveState {
    switch (action.type) {
      case "TOGGLE_BOOKMARK":
        return { archived: !archiveState.archived, clicked: true };
      case "RESET_CLICK":
        return { ...archiveState, clicked: false };
      default:
        return archiveState;
    }
  }
  const bookmarked = bookMarkedChats.some(chat=>chat.session_id === routeSessionId);

  const [archiveState, archiveDispatch] = useReducer<
  React.Reducer<ArchiveState, ArchiveAction>
  >(
    archiveReducer,
    { archived: bookmarked, clicked: false }
  );

  // 点赞点踩触发回调更新缓存数据
  useEffect(() => {
    if (isFunction(handleLikeOrDislike)){
      handleLikeOrDislike?.(messageId, likeState);
    }
  }, [likeState]);
  
  useDebounceEffect(
    () => {
      handleFeedBackBubbleClose('copyVisible', false);
      const timer = setTimeout(() => {
        setCopyState('');
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    },
    [copyState],
    {
      wait: 2000,
    }
  );

  useUpdateEffect(
    () => {
      if (feedbackPopState) return;
      handleFeedBackBubbleClose('downVisible', true);
      handleFeedBackBubbleClose('downTips', true);
      const timer = setTimeout(() => {
        handleFeedBackBubbleClose('downVisible', false);
        handleFeedBackBubbleClose('downTips', false);
      }, 2000);
      return () => {
        clearTimeout(timer);
      };
    },
    [feedbackPopState],
  );

  // 更新点赞点踩
  const updateLikeState = (like: number, oldLike?: number, othersParams?: any) => {
    const params = {
      openId: userInfo?.openid,
      traceId: uuidv4(),
      sessionId: routeSessionId,
      messageId,
      data: {
        like,
        ...othersParams,
      },
    };
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    updateHistory(params, showErrorTips)
      .then((res) => {
        // console.log(res, '点赞点踩更新成功');
        if (res.res_code === 0) {
          // 乐观更新状态
          setLikeState?.(like);
        }
      })
      .catch((err) => {
        // 失败回退状态
        console.log(err, '点赞点踩更新 err');
        setLikeState?.(oldLike);
      });
  };

  const handleCopy = async () => {
    if (copyState) return; // 防止重复点击
    // 复制内容包括：结论文字、Data Insight洞察要点(Data Insight后端未从text中拆解出来，暂时先不处理)
    const textAnswer = answer?.filter(
      (item: { type: string; }) => item?.type === 'text',
    );
    const text =
      textAnswer?.map((item: { value: any; }) => item?.value)?.join('\n') || '';
    const filteredText = stripAnswerProtocolTags(text).replace(/<[^>]*>/g, '');
    const state = await copyToClipboard(filteredText);
    setCopyState(state ? 'success' : 'error');
    // if (state) {
    //   notification.success({
    //     description: formatMessage({ id: 'dba_common_copy_success' }),
    //     duration: 1000,
    //   });
    // } else {
    //   notification.error({
    //     description: formatMessage({ id: 'dba_common_copy_failed' }),
    //     duration: 1000,
    //   });
    // }
  };


  useEffect(() => {
    if (!archiveState.clicked) return;
    const timer = setTimeout(() => {
      archiveDispatch({ type: "RESET_CLICK" });
    }, 2000);
    return () => clearTimeout(timer);
  }, [archiveState.clicked]);
  
  const handleBookmark = async() => {
    const { openid } = userInfo || {};
    if (!openid) return;
    await updateChat(
      {
        sessionId: routeSessionId,
        title: chatList.find(chat=>chat.session_id === routeSessionId)?.title ?? '',
        isBookmarked: !bookmarked,
        openid,
      },
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      showErrorTips,
    );
    fetchChatList();
    archiveDispatch({ type: "TOGGLE_BOOKMARK" });
  };

  const handleBookmarkBubble = (): React.ReactNode => {
    let msgId = "";

    if (archiveState.clicked && archiveState.archived) {
      msgId = "dba_menu_chat_archive_done";
    } else if (archiveState.clicked && !archiveState.archived) {
      msgId = "dba_menu_chat_archive_remove_done";
    } else if (!archiveState.clicked && archiveState.archived) {
      msgId = "dba_menu_chat_archive_remove";
    } else {
      msgId = "dba_menu_chat_archive";
    }

    if (archiveState.clicked && archiveState.archived) {
      return (
        <div className="dba-feedback-operation-copy-contenet">
          <img src={copySuccessIcon} alt="" style={{ width: 16, height: 16, marginRight: 5 }} />
          {formatMessage({ id: msgId })}
        </div>
      );
    }

    return formatMessage({ id: msgId });
  };

  // 高亮反馈区hover态icon
  const handleFeedBackHover = (key: HoveringState, value: boolean) => {
    setFeedBackHoverStat(prev => ({...prev, [key]: value}));
  };

  // 高亮反馈区bubble态消失
  const handleFeedBackBubbleClose = (key: string, value: boolean) => {
    setFeedBackVisibleStat({[key]: value});
  };
  // 判断是否需要禁用反馈功能
  const disableFeedback = useMemo(()=>{
    if (!isDsMode) return false;
    const currentConversation = conversations?.find(
      (conv: any) => conv?.messageId === messageId
    );
    if (!currentConversation) return true;
    return !hasReportDocument([currentConversation]);
  },[conversations, isDsMode, messageId]);
  
  const operationList = [
    {
      icon: kbAddUploadIcon,
      label: formatMessage({ id: 'dba_kb_add_selection_btn' }),
      className: 'dba-feedback-operation-kb-add',
      onClick: () => {
        setKbAddModalOpen();
      },
    },
    {
      operationType: 'like',
      icon: likeState === 1 || hoverUp ? thumbsUpActiveIcon : thumbsUpIcon,
      bubble:
        likeState === 1
          ? formatMessage({ id: 'dba_common_feedback_tips' })
          : formatMessage({ id: 'dba_common_like' }),
      className: classNames('dba-feedback-operation-like', {
        'dba-feedback-operation-like-active': likeState === 1,
      }),
      onClick: () => {
        const map: any = {
          0: 1,
          1: 0,
          '-1': 1,
        };
        buriedBtnPoint({
          pageId: '700501',
          buttonId: '700501009',
          extInfo: JSON.stringify({
            sessionId: routeSessionId,
            like: map?.[likeState],
            messageId,
            message: question,
            from
          }),
          typeId: 'aigc',
        });
        updateLikeState(map?.[likeState], likeState);
      },
      onMouseEnter: () => {
        handleFeedBackHover(HoveringState.hoverUp, true);
      },
      onMouseLeave: () => {
        handleFeedBackHover(HoveringState.hoverUp, false);
      },
      isHidden: disableFeedback,
    },
    {
      operationType: 'dislike',
      icon:
        likeState === -1 || hoverDown ? thumbsDownActiveIcon : thumbsDownIcon,
      bubble:
        likeState === -1  || downTips
          ? formatMessage({ id: 'dba_common_feedback_tips' })
          : formatMessage({ id: 'dba_common_unlike' }),
      className: classNames('dba-feedback-operation-unlike', {
        'dba-feedback-operation-unlike-active': likeState === -1,
      }),
      bubbleProps: {
        visible: downVisible,
        closeOnScroll: true,
        onVisibleChange: (visible: boolean) => {
          handleFeedBackBubbleClose('downVisible', visible);
        },
      },
      onClick: () => {
        // 如果在点踩状态，直接返回，不需要弹框，调接口即可
        if (likeState === -1) {
          handleDislikeFeedback();
          return;
        }
        // 如果在点赞状态，先重置掉点赞的状态
        if (likeState === 1) { 
          setLikeState?.(0);
        }
        setFeedbackPopOpen();
      },
      onMouseEnter: () => {
        handleFeedBackHover(HoveringState.hoverDown, true);
      },
      onMouseLeave: () => {
        handleFeedBackHover(HoveringState.hoverDown, false);
      },
      isHidden: disableFeedback,
    },
    {
      icon: hoverArchive || bookmarked ? ArchiveHighlightIcon :  ArchiveIcon,
      bubble: handleBookmarkBubble(),
      onMouseEnter: () => 
        handleFeedBackHover(HoveringState.hoverArchive, true),
      onMouseLeave: () => 
        handleFeedBackHover(HoveringState.hoverArchive, false),
      onClick: handleBookmark,     
    },
    {
      icon: hoverCopy || copyState === 'success' ? copyActiveIcon : copyIcon,
      // eslint-disable-next-line no-nested-ternary
      bubble:
        copyState === 'success' ? (
          <div className="dba-feedback-operation-copy-contenet">
            <img src={copySuccessIcon} alt="" style={{ width: 16, height: 16, marginRight: 5 }} />
            {formatMessage({ id: 'dba_common_copy_success' })}
          </div>
        ) : copyState === 'error' ? (
          <div className="dba-feedback-operation-copy-contenet">
            <Icon type="error" />
            {formatMessage({ id: 'dba_common_copy_failed' })}
          </div>
        ) : (
          formatMessage({ id: 'dba_common_copy' })
        ),
      bubbleProps: {
        visible: copyVisible,
        closeOnScroll: true,
        onVisibleChange: (visible: boolean) => {
          if (copyState) return;
          handleFeedBackBubbleClose('copyVisible', visible);
        },
      },
      onClick: handleCopy,
      onMouseEnter: () => {
        handleFeedBackHover(HoveringState.hoverCopy, true);
      },
      onMouseLeave: () => {
        handleFeedBackHover(HoveringState.hoverCopy, false);
      },
    },
    {
      icon: hoverRefresh ? refreshActiveIcon : refreshIcon,
      bubble: formatMessage({ id: 'dba_common_refresh' }),
      onClick: () => {
        handleRefreshConfirm();
      },
      onMouseEnter: () => {
        handleFeedBackHover(HoveringState.hoverRefresh, true);
      },
      onMouseLeave: () => {
        handleFeedBackHover(HoveringState.hoverRefresh, false);
      },
    },
    {
      icon: hoverShare && !sensitiveConversation ? shareActiveIcon : shareIcon,
      bubble: sensitiveConversation
        ? formatMessage({ id: sensitiveDataInfo.type })
        : formatMessage({ id: 'dba_menu_share' }),
      className: classNames(sensitiveConversation && 'dba-share-operation-sensitive-content'),
      bubbleProps: { class: 'tea-bubble tea-bubble--bottom dba-share-operation-sensitive-content-bubble' },
      onClick: () => {
        buriedBtnPoint({
          pageId: '700501',
          buttonId: '700501008',
          extInfo: JSON.stringify({
            sessionId: routeSessionId,
            from: from === 'agent' ? 'chatPage' : from,
          }),
          typeId: 'aigc',
        });
        if (sensitiveConversation) return;
        shareOnClickHandler(routeSessionId, setShowShareChatDialog);
      },
      onMouseEnter: () => {
        handleFeedBackHover(HoveringState.hoverShare, true);
      },
      onMouseLeave: () => {
        handleFeedBackHover(HoveringState.hoverShare, false);
      },
      // 只有最后一个qa显示分享按钮
      isHidden: !isLastQA,
    },
  ];

  // 只在弹窗打开时提取正文（type=text，去除协议标签）
  const answerText = useMemo(() => {
    if (!kbAddModalVisible) return '';
    const textAnswer = answer?.filter(
      (item: { type: string; }) => item?.type === 'text',
    );
    const text =
      textAnswer?.map((item: { value: any; }) => item?.value)?.join('\n') ||
      '';
    return stripAnswerProtocolTags(text).replace(
      /<strong>(.*?)<\/strong>/g,
      '**$1**',
    );
  }, [answer, kbAddModalVisible]);

  // 过滤掉隐藏的操作项
  const finalOperations = operationList.filter(operation => !operation?.isHidden);

  const handleDislikeFeedback = useMemoizedFn((val?: object) => {
    const map: any = {
      0: -1,
      1: -1,
      '-1': 0,
    };
    let result = [];
    let otherParams;
    if (!isEmpty(val)){
      result= val?.feedback?.map((id: string) => {
        const matchedItem = val?.list?.find((item: { id: string; }) => item?.id === id);
        return {
          type_id: matchedItem?.id,
          type_name: matchedItem?.text
        };
      });
      otherParams = {feedback: result, "feedback_content": val?.feedbackContent,};
    }
    updateLikeState(map?.[likeState], likeState, otherParams);
    buriedBtnPoint({
      pageId: '700501',
      buttonId: '700501010',
      extInfo: JSON.stringify({
        sessionId: routeSessionId,
        like: map?.[likeState],
        messageId,
        message: question,
        from,
      }),
      typeId: 'aigc',
    });
    setFeedbackPopClose();
  });

 

  return (
    <>
      <Operation
        className={classNames('dba-feedback-operation', className)}
        operationList={finalOperations}
      />
      <FeedbackPopConfirm
        {...{
          visible: feedbackPopState,
          onClose: ()=>{
            setFeedbackPopClose();
            handleDislikeFeedback();
          },
          onConfirm: handleDislikeFeedback,
          title: formatMessage({ id: 'dba_chat_feedback_title' }),
          messageList: FEED_BACK_MESSAGES_LIST
        }}
      />
      {kbAddModalVisible && (
        <KnowledgeBaseAddModal
          visible
          defaultContent={answerText}
          onClose={setKbAddModalClose}
        />
      )}
    </>
  );
};
export default FeedbackOperation;
